const BASE_URL = process.env.REACT_APP_API_URL ?? 'https://copilot.nagaco.com/api/';
const FORM_URL = process.env.REACT_APP_FORM_URL ?? 'https://copilot.nagaco.com/api/'; // form dynamic with file .json
const AUTH_URL = process.env.REACT_APP_SSO_ENDPOINT ?? 'https://sso.nagaco.com/';
const API_AUTH_URL = process.env.REACT_APP_SSO_API ?? 'https://sso.nagaco.com/api/';
const NOTI_SERVICE_URL = process.env.REACT_APP_NOTIFICATION_API_URL ?? 'https://noti.nagaco.com/api/';
const MONGO_SERVICE_URL = process.env.REACT_APP_MONGO_API_URL ?? 'https://api.nagaco.com/com/';

export const HELP_URL = `/help`;

export const HELP_NOT_FOUND_URL = `${HELP_URL}/not_found.txt`;

const dev = {
    API_ENDPOINT_URL: BASE_URL,
    API_FORM_URL: FORM_URL,
    API_AUTH_URL: API_AUTH_URL,
    AUTH_ENDPOINT_URL: AUTH_URL,
    NOTI_SERVICE_URL: NOTI_SERVICE_URL,
    MONGO_SERVICE_URL: MONGO_SERVICE_URL,
};

const prod = {
    API_ENDPOINT_URL: BASE_URL,
    API_FORM_URL: FORM_URL,
    API_AUTH_URL: API_AUTH_URL,
    AUTH_ENDPOINT_URL: AUTH_URL,
    NOTI_SERVICE_URL: NOTI_SERVICE_URL,
    MONGO_SERVICE_URL: MONGO_SERVICE_URL,
};

const test = {
    API_ENDPOINT_URL: BASE_URL,
    API_FORM_URL: FORM_URL,
    API_AUTH_URL: API_AUTH_URL,
    AUTH_ENDPOINT_URL: AUTH_URL,
    NOTI_SERVICE_URL: NOTI_SERVICE_URL,
    MONGO_SERVICE_URL: MONGO_SERVICE_URL,
};

const getEnv = () => {
    //let obj=JSON.parse(process.env.NODE_ENV)
    // console.log(process.env.NODE_ENV)
    // const myObject = (JSON.parse(process.env.API)).dev
    // console.log('myObject',myObject)
    switch (process.env.NODE_ENV) {
        case 'development':
            return dev;
        case 'production':
            return prod;
        case 'test':
            return test;
        default:
            break;
    }
};

export const env = getEnv();
